import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
// import { MdEdit } from "react-icons/md"
import individualServices from "../../Services/individualServices";
import { ChangeStatus, AddAmountModal } from "../../Components";
import Loader from "../../Components/Loader";
// import locationServices from '../../Services/locationServices'
import { RiMoneyDollarBoxFill } from "react-icons/ri";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { revenuecostService } from '../../Services/revenuecostService'
import JobService from "../../Services/JobService";
import moment from "moment";
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

// import {Button} from "react-bootstrap-v5";

export const JobAmountAssignList = (props) => {
  const [valueSchema, setValueSchema] = useState({
    job_advance_payment:''
  })
  const [jobList, setJobList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isAmountModalOpen, setIsAmountModalOpen] = useState(false);
  const [advancePayments, setAdvancePayments] = useState([]);
  const [totalPayments, setTotalAdvancePayments] = useState(0);

  const history = useHistory();
  const [userDetails, setUserDetails] = useState(history.location.state)
  const validationSchema = Yup.object({
    job_advance_payment: Yup.number().min(0,'Must Be Positive Numbers').max(userDetails?.advance_payment,'Must Be Less Than Advance Amount').required('Required'),
  })


  useEffect(() => {
    signInIntuit()
    getjobList();
    getUserAdvancePaymentList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getjobList = () => {
    if (userDetails) {
      let param = { ...pagination, page: currentPage, email: userDetails?.user_email };
      if (pagination.search) {
        param["page"] = 1;
      }
      JobService.getPayCustomerJob(param).then((res) => {
        if (res.status) {
          setLoader(false);
          setJobList(res.data);
          setPagination({ ...pagination, ...res.pagination });
        } else {
          setLoader(false);
        }
      });
    }
  };

  const getUserAdvancePaymentList = () => {
    if (userDetails) {
      let param = { user_id: userDetails?._id };
      
      JobService.getUserAdvancePayments(param).then((res) => {
        if (res.status) {
          setLoader(false);
          if(res.data.length > 0){
            let options = res.data.map((item) => {
              return {label: item.amount, value: item.quickbook_payment_id}
            })
            
            // Totaling the advance amount
            let totalAmt = res.data.reduce((total, item) => Number(item.amount) + total, 0)
            
            setAdvancePayments(options)
            // setValueSchema({...valueSchema, job_advance_payment: Number(totalAmt)})
            setTotalAdvancePayments(totalAmt)
          }
        } else {
          setLoader(false);
        }
      });
    }
  };

  // const setUserAdvancePayment = () => {

  // }

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      user_status: isModalOpen.user_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    individualServices.update_individual(postData).then((res) => {
      setIsModalOpen(false);
      getjobList();
    });
  };


  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const signInIntuit = () => {
    // var win;
    // var parameters = "location=1,width=800,height=650";
    // parameters += ",left=" + (window.innerWidth - 800) / 2 + ",top=" + (window.innerHeight - 650) / 2;

    revenuecostService.qbookAuth().then(result => {
      // Launch Popup
      // win = window.open(result, 'connectPopup', parameters);
      // this.props.history.push(result)
      if (!result.status) {
        localStorage.setItem('redirectUri', window.location.href)
        window.location.href = result.uri
      }

    })
  }

  const formik = useFormik({
    initialValues: valueSchema,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: ((values) => {
      
      let amounts = advancePayments.map((item) => {
        // return {TxnId: item.value, amount: values.job_advance_payment,applied:false, TxnType: 'Payment'}
        return {TxnId: item.value, amount: userDetails?.advance_payment,applied:false, TxnType: 'Payment'}
      })

      setLoader(true)
      let postData = {
        job_advance_payment: JSON.stringify(amounts),
        email: userDetails?.user_email,
        job_id: isAmountModalOpen._id
      }
      JobService.assignPaymentToJob(postData).then(res => {
        if (res.status) {
          let newUser = {...userDetails};
          newUser.advance_payment = res?.data?.advance_payment
          history.replace({ ...history.location, state: newUser });
          setValueSchema({job_advance_payment:''})
          setUserDetails(newUser)
          setIsAmountModalOpen(false)
          formik.resetForm();  
          getjobList();
          getUserAdvancePaymentList();
        } else {
          setLoader(false)
          toast.error(res.message)
        }
      })
    }),
  });
  const handleChange = (e) => {
    setValueSchema({...valueSchema ,job_advance_payment: e.target.value})
  }

  return (
    <div className="row">
      <Loader position={"fixed"} isShow={loader} />
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="w-25 pe-5 ">
                <input
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getjobList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getjobList()
                  }
                />
              </div>
              <div className="d-flex">
                <label>User Balance: </label>
                <b>{(userDetails?.advance_payment) ? userDetails?.advance_payment : 0}</b>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S.No</th>
                    <th>Job Id</th>
                    <th>Customer Email</th>
                    <th>Actual Amount</th>
                    <th>Agreed Amount</th>
                    <th>Assign Job Advance</th>
                    <th>Date</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  {jobList.length > 0 &&
                    jobList.map((item, key) => (
                      <tr key={`item_${key.toString()}`}>
                        <td>{key + 1}</td>
                        <td>{item.job_token}</td>
                        <td>{(item?.customer_details?.email)}</td>
                        <td>{item?.payment_information?.actual_amount}</td>
                        <td>{item?.payment_information?.agreed_amount}</td>
                        <td>{item?.payment_information?.job_advance_payment}</td>
                        <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                        <td>
                          <RiMoneyDollarBoxFill
                            title="Assgin advance amount to job"
                            className="pointer"
                            onClick={() => {userDetails?.advance_payment ? setIsAmountModalOpen(item) : toast.error('Balance not available to assign')}}
                            // onClick={() => setIsAmountModalOpen(item)}
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {jobList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {jobList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          {/* <Loader isShow={loader} /> */}
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${isModalOpen.user_status === "ACTIVE" ? "Inactive" : "Active"
              } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => setDeleteModalOpen(false)}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
        {Boolean(isAmountModalOpen) && (
          <AddAmountModal
            isOpen={Boolean(isAmountModalOpen)}
            title="Assign Amount To Job"
            message={`Are you sure want to add this amount ?`}
            onSubmitEvent={() => formik.handleSubmit()}
            handleClose={() => setIsAmountModalOpen(false)}
            buttonText={{ no: 'Cancel', yes: 'Submit' }}
            centerBtn
            child={<div>
              <form className="control-form">
                <div className="mb-4 col-12">
                  <label className="form-label">Assign Amount: </label>

                   <h2>{userDetails?.advance_payment || 0} </h2>
                   {/* <input
                      className="form-control"
                      type="number"
                      value={valueSchema.job_advance_payment}
                      name='job_advance_payment'
                      onChange={(e) => handleChange(e)}
                    />    
                     {formik.touched.job_advance_payment && formik.errors.job_advance_payment ? (
                      <div className="ms-1 text-danger">{formik.errors.job_advance_payment}</div>
                    ) : null}               */}
                </div>
              </form>

            </div>}
          />
        )}

      </div>
    </div>
  );
};
